import { render, staticRenderFns } from "./TaxGroupViewLogs.vue?vue&type=template&id=39d65134&"
import script from "./TaxGroupViewLogs.vue?vue&type=script&lang=js&"
export * from "./TaxGroupViewLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports